export const combineEans = (eans: string[]): string => {
  const startString = "?eans=";
  if (eans.length === 0) {
    return "";
  }
  if (eans.length === 1) {
    return startString + eans[0];
  }
  return startString + eans.join("&eans=");
};

export const combineSearchParams = (searchParams: string[]): string => {
  const startString = "?searchParam=";
  if (searchParams.length === 0) {
    return "";
  }
  if (searchParams.length === 1) {
    return startString + searchParams[0];
  }
  return startString + searchParams.join("&searchParam=");
};

export const combineInternalRefs = (internalRefs: string[]): string => {
  const startString = "?internalRefs=";
  if (internalRefs.length === 0) {
    return "";
  }
  if (internalRefs.length === 1) {
    return startString + internalRefs[0];
  }
  return startString + internalRefs.join("&internalRefs=");
};

export const createUrlQueryParams = (
  url: string,
  searchStrings: string[] = [],
  page?: number,
  limit?: number,
  exactMatch?: boolean
): string => {
  let modifiedUrl = url;

  if (searchStrings.length > 0) {
    modifiedUrl += modifiedUrl.includes("?")
      ? `&searchParam=${searchStrings.join("&searchParam=")}`
      : `?searchParam=${searchStrings.join("&searchParam=")}`;
  }

  if (page) {
    modifiedUrl += modifiedUrl.includes("?")
      ? `&page=${page}`
      : `?page=${page}`;
  }

  if (limit) {
    modifiedUrl += modifiedUrl.includes("?")
      ? `&limit=${limit}`
      : `?limit=${limit}`;
  }

  if (exactMatch === true) {
    modifiedUrl += modifiedUrl.includes("?")
      ? `&exactMatch=true`
      : `?exactMatch=true`;
  }

  if (exactMatch === false) {
    modifiedUrl += modifiedUrl.includes("?")
      ? `&exactMatch=false`
      : `?exactMatch=false`;
  }

  return modifiedUrl;
};
